import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalParams, Translation, Localization, eAppContext, QueovalDik, LoginDate, PageInfo, ParamApplication, QResult } from '../models/global/class.global';
import { HttpService } from './dataAccess.service';

@Injectable({
  providedIn: 'root'
})

export class CoreService {

  private storage: QueovalDik[] = [];

  // #region public properties
  public traductionSubject$ = new BehaviorSubject<boolean>(true);

  /** @description application context */
  get Context(): eAppContext {
    return this.appParams.context;
  }

  /** @description client database name */
  get ClientDB(): string {
    return this.appParams.dbname;
  }

  /** @description login datetime (for checking eventual expiration) */
  private loginDate: LoginDate;
  get LoginDate(): LoginDate {
    return this.loginDate;
  }
  set LoginDate(item: LoginDate) {
    this.loginDate = item;
  }

  /** @description class with global configuration values to share between app views */
  private appParams: GlobalParams;
  get AppParams(): GlobalParams {
    return this.appParams;
  }
  set AppParams(item: GlobalParams) {
    this.appParams = item;
  }

  /** @description translation data */
  get Trad(): Translation {
    return this.appParams.Translation;
  }
  set Trad(traduction: Translation) {
    this.appParams.Translation = traduction;
  }

  /** @description reference to the current url */
  private currentUrl: PageInfo = new PageInfo('');
  get CurrentUrl(): PageInfo {
    return this.currentUrl;
  }
  set CurrentUrl(url: PageInfo) {
    this.currentUrl = url;
  }

  /** @description url stockage for url-refresh management */
  private stockedUrl: string = '';
  get StockedUrl(): string {
    return this.stockedUrl;
  }
  set StockedUrl(url: string) {
    this.stockedUrl = url;
  }

  /** @description url stockage for url-refresh management */
  get AppLoginSite(): string {
    return this.appParams.appLoginSite;
  }

  get ApiUrl(): string {
    return this.AppParams.apiUrl;
  }
  // #endregion


  constructor(private http: HttpService) { }

  /** @description get user authorization for the specified function
  * @param fonctionName the function to authorize
  * @return
  */
  getAutorisation(fonctionName: string): boolean {
    let result: boolean = false;
    if (this.appParams && this.appParams.Role && this.appParams.Role.Autorisation) {
      this.appParams.Role.Autorisation.forEach((row: any) => {
        if (row['Name_FON'] === fonctionName) {
          result = row['VisibFON'] ? (row['AccesAUT'] ? (row['AccesAUT'] === true ? true : false) : false) : false;
        }
      });
    }
    return result;
  }

  /** @description get localized alert for the specified key
  * @param key alert key
  * @return localized value
  */
  //getAlert(key: string): string {
  //  let text: string = '';
  //  if (this.appParams.Translation && this.appParams.Translation.Alerts) {
  //    const a: Array<Localization> = this.appParams.Translation.Alerts.filter((e: Localization) => e.Key === key);
  //    if (a && a.length > 0) { text = a[0].Value; }
  //  }
  //  // in case we have not found the key among the alerts, we look for it amongs labels
  //  if (text === '') {
  //    if (this.appParams.Translation && this.appParams.Translation.Labels) {
  //      const l: Array<Localization> = this.appParams.Translation.Labels.filter((e: Localization) => e.Key === key);
  //      if (l && l.length > 0) { text = l[0].Value; }
  //    }
  //  }
  //  return text === '' ? '[localized message not found]' : text;
  //}

  /** @description get localized label for the specified key
  * @param key label key
  * @return localized value
  */
  //getAlert(key: string): string {
  //  let text: string = '';
  //  if (this.appParams.Translation && this.appParams.Translation.Alerts) {
  //    const a: Array<Localization> = this.appParams.Translation.Alerts.filter((e: Localization) => e.Key === key);
  //    if (a && a.length > 0) { text = a[0].Value; }
  //  }
  //  // in case we have not found the key among the alerts, we look for it amongs labels
  //  if (text === '') {
  //    if (this.appParams.Translation && this.appParams.Translation.Labels) {
  //      const l: Array<Localization> = this.appParams.Translation.Labels.filter((e: Localization) => e.Key === key);
  //      if (l && l.length > 0) { text = l[0].Value; }
  //    }
  //  }
  //  return text === '' ? '[localized message not found]' : text;
  //}

  /** @description get localized trad for the specified key
  * @param key trad key
  * @return localized value
  */
  getTrad(key: string, ...args: string[]): string {
    let text: string = '';
    if (this.appParams && this.appParams.Translation && this.appParams.Translation.Trads) {
      const l: Array<Localization> = this.appParams.Translation.Trads.filter((e: Localization) => e.Key.toUpperCase() === key.toUpperCase());
      if (l && l.length > 0) { text = l[0].Value; }
    }

    args.forEach((itemMsg, index) => { text = text.replace(`{${index}}`, itemMsg); });
    return text === '' ? `[${key}]` : text;
  }

  /** @description get webkey.config file specific key
  * @param key eConfigKey key
  * @return config value
  */
  getConfigKey(key: string): string {
    const k: QueovalDik[] = this.appParams.ConfigKeys.filter((e: QueovalDik) => e.key === key);
    return k.length > 0 ? k[0].value : '';
  }

  /** @description splashscreen management
  * @param show hide or display the screen
  * @return void
  */
  showSplash(show: boolean): void {
    const splash: HTMLElement | null = document.getElementById('divCustomSpash');
    if (splash) {
      splash.style.display = show ? 'block' : 'none';
    }
  }

  /** @description data stockage (set)
  * @param key
  * @param value
  * @return void
  */
  stockData(key: string, value: string): void {
    const d: QueovalDik[] = this.storage.filter((item: QueovalDik) => item.key === key);
    if (d.length > 0)
      d[0].value = value;
    else
      this.storage.push(new QueovalDik(key, value));
  }

  /** @description data stockage (get)
  * @param key
  * @param remove
  * @return string
  */
  getStocked(key: string, remove: boolean = false): string {
    let val: string = '';
    let ind: number = -1;
    for (let n: number = 0; n < this.storage.length; n++) {
      if (this.storage[n].key === key) {
        val = this.storage[n].value;
        ind = n;
      }
    }
    if (remove && ind > -1) {
      this.storage.splice(ind, 1);
    }
    return val;
  }

  GetParamsApplication(params: Array<ParamApplication>): Observable<Array<ParamApplication>> {
    return this.http.postHttp<QResult<Array<ParamApplication>>>(`${this.AppParams.apiUrl}api/main/GET/PARAMETRES_APPLICATION`, params).pipe(
      map((result: QResult<Array<ParamApplication>>) => {
        return result.Value;
      }));
  }
  SetParamsApplication(params: Array<ParamApplication>): Observable<number> {
    return this.http.postHttp<QResult<number>>(`${this.AppParams.apiUrl}api/main/SET/PARAMETRES_APPLICATION`, params).pipe(
      map((result: QResult<number>) => {
        return result.Value;
      }));
  }
}
